import API from '@/views/Fdc/Apis/'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

/**
 * Report > Fault Analysis Report - Area Analysis Chart
 */
export default {
  name: 'AreaAnalysisChart',
  props: {
    parentInfo: {
      type: Object,
      default () {
        return null
      }
    }
  },
  watch: {
    /**
     * parentInfo 변화 감지
     * Area Analysis Chart data를 조회합니다.
     */
    parentInfo () {
      this.search(this.parentInfo)
    }
  },
  methods: {
    /**
     * Area Analysis Chart data 조회
     * @param {Object} condition 조회 조건
     */
    async search (condition) {
      let payload = {
        fab: condition.fab,
        area: condition.area,
        eqpModel: condition.eqpModel,
        fromDate: condition.fromDate,
        toDate: condition.toDate
      }

      this.condition = condition

      await API.Report.getFaultChartAreas(payload, this.callbackAreaChart)
    },
    /**
     * Area Analysis Chart data 조회 callback
     * @param {*} response Area Analysis Chart data 조회 결과
     */
    callbackAreaChart (response) {
      if (response && response.status === 200) {
        this.drawChart(response.data)

        if (response.data[0].labels.length > 0) {
          this.condition.area = response.data[0].labels[0]
          this.$emit('data-selected', this.condition)
        } else {
          this.$emit('data-selected', null)
        }
      }
    },
    /**
     * Draw Chart
     * @param {*} traces plotly chart data
     */
    drawChart (traces) {
      // private final String type = "pie";
      // private final String textposition = "inside";
      // private final String texttemplate = "%{label}<br>%{value:.2percent}";
      // private final String hovertemplate = "Area: %{label}<br>Cnt: %{text:,}<extra></extra>";
      // private final Boolean showlegend = true;
      traces.forEach(trace => {
        trace.type = 'pie'
        trace.name = 'Area'
        trace.textposition = 'inside'
        trace.texttemplate = '%{label}<br>%{value:.2%}'
        trace.hovertemplate = '<b>Area:</b> %{label}<br><b>Cnt:</b> %{text.count:,}<extra></extra>'
      })
      const layout = {
        hoverlabel: {
          align: 'left'
        }
      }
      const config = {
        responsive: true,
        scrollZoom: true,
        displaylogo: false,
        displayModeBar: true
      }
      BriqueChart.newPlot('areaAnalysisChart', traces, layout, config).then(() => {
        let chart = document.querySelector('#areaAnalysisChart')
        chart.on('plotly_click', event => {
          this.condition.area = event.points[0].label
          this.$emit('data-selected', this.condition)
        })
      })
    }
  },
  data () {
    return {
      // areaAnalysisItems: [] // Area Analysis Chart data
      // selectedIndex: null // 선택된 chart data index
    }
  }
}
